<template>
	<el-dialog
	  title="用户续费"
	  :visible.sync="dialogVisible"
	  width="30%">
	    <div v-for="(item,i) in arr" :key="i" style="display: flex;align-items: center;margin-bottom: 10px;">
			<span>用户ID：</span>
			<el-input placeholder="请输入用户ID" v-model="item.userid" style="width: 60%;" size="small"></el-input>
			<el-button type="danger" size="small" style="margin-left: 10px;" v-if="i>0" @click="arr.splice(i,1)">移除</el-button>
		</div>
		
		<div style="width: 100%;margin-top: 30px;display: flex;align-items: center;justify-content: center;">
			<el-button type="primary" @click="arr.push({userid:''})">新增</el-button>
			<el-button type="success" @click="user_gxxufei_save()">确定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import { user_gxxufei_save } from "@/api/huanjing"
	export default {
		data(){
			return{
				dialogVisible:false,
				arr:[{userid:''}],
				huanjingid:''
			}
		},
		watch:{
			dialogVisible(e){
				if(e==false){
					this.huanjingid = ""
					this.arr = [{userid:''}]
				}
			},
		},
		methods:{
			user_gxxufei_save(){
				let is = 1;
				let userarr = [];
				this.arr.forEach(r=>{
					if(!r.userid){
						is = 0;
					}
				})
				if(is==0){
					this.$message.error("用户ID不能为空且最少一个");
					return;
				}
				this.arr.forEach(r=>{
					userarr.push(r.userid);
				})
				let data = {
					huanjingid:this.huanjingid,
					userarr:userarr
				};
				 const loading = this.$loading({
				  lock: true,
				  text: '提交中',
				  spinner: 'el-icon-loading',
				  background: 'rgba(0, 0, 0, 0.7)'
				});
				user_gxxufei_save(data).then(res=>{
					loading.close();
					console.log("成功",res.data);
					this.$message.success("成功");
					this.dialogVisible = false
					this.$emit("succ",res.data.orderid);
				}).catch(()=>{
					loading.close();
				})
			},
			show(huanjingid){
				this.huanjingid = huanjingid
				this.dialogVisible = true
			}
		}
	}
</script>

<style lang="scss">
	
</style>


// WEBPACK FOOTER //
// src/views/erqi/userxufei.vue